import React from 'react'
import { useHistory } from 'react-router-dom'

//images
import procedureIcon from '../../../../assets/img/pages/icons/procedure.png'
import ProcedureOptions from '../../../partials/ProcedureOptions';

function TableProcedures(props) {

    const history = useHistory();

    const handleEdit = e => {
        let currentUrl = e.target.parentElement.getAttribute('data-url')

        if (currentUrl) {
            history.push(currentUrl)
        }
    }

    return (
        props.data ?
            <table>
                <thead>
                    <tr>
                        <th>Вх. номер/Дата</th>
                        <th>Вид процедура</th>
                        {/* <th>Фирма</th>
                        <th>Адрес</th> */}

                        {props.tabGroup === 'expiring' &&
                            <th>
                                Дата на изтичане
                        </th>
                        }

                        <th>Статус</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.map(p =>

                        <tr key={p.id} onClick={handleEdit} data-url={
                            p.subtype_id == 2 ?
                                'tourism/change/config/' + p.id
                                :
                                p.subtype_id == 3 ?
                                    'tourism/close/config/' + p.id
                                    :
                                    p.canceled ?
                                        '/tourism/cancel/edit/' + p.type.relation + '/' + p.id
                                        :
                                        p.categorization_type_id == 1
                                            ? '/tourism/config/restaurant/' + p.id
                                            : '/tourism/config/hotel/' + p.id
                        }>
                            <td>
                                <img src={procedureIcon} alt="procedure" />
                                {p.request.no || p.request.date ?
                                    <>
                                        {p.request.no ? `№${p.request.no}/` : ''}{p.request.date_dmy}
                                    </>
                                    :
                                    '-'
                                }
                            </td>
                            <td>
                                {p.name}
                            </td>
                            {/* <td>
                                {p.company && p.company.name ?
                                    p.company.name
                                    :
                                    '-'
                                }
                            </td>
                            <td>
                                {p.company
                                    ? [
                                        p.company.town && p.company.town.name,
                                        p.company.street ? `${p.company.street.suff} ${p.company.street.name} ${p.company.street_number ? p.company.street_number : ''}` : ''
                                    ].join(', ')
                                    : '-'}
                            </td> */}
                            {props.tabGroup === 'expiring' &&
                                <td>
                                    {p.license_period_to_dmy || '-'}
                                </td>
                            }
                            <td className={`current-step ${p.actual_phase_id == 0 ? 'finished-steps' : ''} ${p.canceled ? 'canceled' : ''}`}>
                                {p.actual_phase_id != 0 ? `${p.actual_phase_id}.` : ''} {p.actual_phase_id == 0 && !p.canceled ? '' : p.phase}
                            </td>

                            <td>
                                {p.subtype_id !== 3 && !props.hasClosingProcedure &&
                                    <ProcedureOptions
                                        id={p.id}
                                        procedureId={p.procedure_id}
                                        type={p.type.relation}
                                        typeId={p.type_id}
                                        phaseId={p.actual_phase_id}
                                        closeable={p.closeable}
                                        deletable={p.deletable}
                                        cancelable={p.cancelable}
                                        refreshData={props.refreshData}
                                    />
                                }
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            : ''
    )
}

export default TableProcedures;
